<div class="app-toolbar">
    <p-toolbar styleClass="bg-danger shadow-2 w-full" 
    [style]="{ 'border-radius': '0rem', 'background-image': 'linear-gradient(to right, var(--red-500), var(--red-800))', 'height': '10vh' }">
        <!-- <div class="p-toolbar-group-start">
            <i class="pi pi-bars px-2" style="color: #fff; cursor: pointer;" (click)="showMenu()"></i>
        </div> -->
        <div class="p-toolbar-group-center">
        </div>
        <div class="p-toolbar-group-end">
            <i class="pi pi-user px-4" style="color: #fff; cursor: pointer;" (click)="op.toggle($event)"></i>
            <p-overlayPanel #op>
                <div class="flex flex-column gap-2">
                    <span class="text-primary mb-2">
                        <i class="pi pi-user text-primary"></i> &nbsp; 
                        {{userData.getUserInfo().username | uppercase}}
                    </span>                    
                    <span class="text-primary">
                        <i class="pi pi-envelope text-primary"></i> &nbsp; 
                        {{userData.getUserInfo().email}}
                    </span>
                    <hr style="margin-top: 6px; margin-bottom: 6px;">
                    <div>
                        <div class="flex flex-row justify-content-center align-items-center" style="cursor: pointer;">
                            <i class="pi pi-sign-out text-2xl text-primary"></i>
                            <span class="font-medium text-primary ml-2" (click)="loadLogout()">
                                LOGOUT
                            </span>
                        </div>
                    </div>
                </div>
            </p-overlayPanel>
            <i class="pi pi-filter px-4" style="color: #fff; cursor: pointer;" (click)="openSidebar()"></i>
        </div>
    </p-toolbar>
</div>